export const formatDate = (date) => {
  // this assumes that the date is valid date object
  // otherwise we should use a proper library to validate the date, like day.js
  const d = new Date(date)
  const year = d.getFullYear()
  // get full month name
  const month = d.toLocaleString('default', { month: 'long' })
  const day = d.getDate()
  const hours = d.getHours()
  // get minutes with leading zeros
  const minutes = ('0' + d.getMinutes()).slice(-2)
  return `${day}. ${month} ${year}, ${hours}:${minutes}`
}
